import { loadDevMessages, loadErrorMessages } from '@apollo/client/dev'

import { ApolloProvider } from '@apollo/client/react'
import { CssBaseline } from '@mui/material'
import { createRoot } from 'react-dom/client'
import AppMain from './AppMain'
import { client } from './apollo'
import { getAppInfo } from './config'
import LoginRedirector from './LoginRedirector'

if (getAppInfo().deployEnv === 'dev') {
  loadDevMessages()
  loadErrorMessages()
}

function App() {
  return (
    <ApolloProvider client={client}>
      <CssBaseline />
      <LoginRedirector>
        <AppMain />
      </LoginRedirector>
    </ApolloProvider>
  )
}

export default App

const rootEl = document.getElementById('root')

if (rootEl) {
  createRoot(rootEl).render(<App />)
}
